import { trimLength } from './string-tools';

export const MAX_AUTHOR_NAME_LENGTH = 100;

export function normalizeAuthorName(name: string): string {
    return trimLength(name.trim(), MAX_AUTHOR_NAME_LENGTH) || 'Anonimowy użytkownik';
}
